import { MDBIcon } from 'mdb-react-ui-kit';
import React from 'react'
import { copyToClipboard } from '../../Utils/textHelper';

import styles from './style.module.scss';

function ActiveText({link, text, isScanTx, isScanAddress, isSettings}) {
    if (isScanTx){
        link = process.env.REACT_APP_ETHERSCAN_BASE_LINK+'/tx/'+text
    } else if (isScanAddress) {
        link = process.env.REACT_APP_ETHERSCAN_BASE_LINK+'/address/'+text
    }
  return (
    <div className={isSettings? styles.containerSettings: styles.container}>
        <div className={styles.copyClipboard} onClick={() => copyToClipboard(text)} >
            {text}
        </div>
        {link ? (<MDBIcon fas icon="external-link-alt" className={styles.iconLink}
                  onClick={() => window.open(link)}/>) : null}
    </div>
  )
}

export default ActiveText;